const io=new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){
    const el=e.target;
    const sibs=[...el.parentElement.children].filter(c=>c.classList.contains('card')&&!c.classList.contains('in'));
    const idx=sibs.indexOf(el);
    el.style.transitionDelay=(el.classList.contains('card')&&idx>-1?Math.min(idx,6)*60:0)+'ms';
    el.classList.add('in');io.unobserve(el);
  }
}),{threshold:.07});
document.querySelectorAll('.rv,.card,.ncard').forEach(el=>{if(el.classList.contains('ncard'))el.classList.add('rv','zoomrv');io.observe(el)});

const prog=document.getElementById('prog');
addEventListener('scroll',()=>{
  const h=document.documentElement;
  prog.style.width=(h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+'%';
},{passive:true});

document.getElementById('filters').addEventListener('click',e=>{
  const b=e.target.closest('.fbtn');if(!b)return;
  document.querySelectorAll('.fbtn').forEach(x=>x.classList.remove('on'));b.classList.add('on');
  const f=b.dataset.f;
  document.querySelectorAll('#grid .card').forEach(c=>{
    const show=(f==='all'||c.dataset.cat===f);
    if(show){c.classList.remove('hide');requestAnimationFrame(()=>requestAnimationFrame(()=>{c.classList.remove('fading');c.classList.add('in');c.style.transitionDelay='0ms'}));}
    else{c.classList.add('fading');setTimeout(()=>c.classList.add('hide'),260);}
  });
});